module.exports = __webpack_public_path__ + "img/date_small.fc99d3b4.svg";